export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: URL) => {
  window.gtag('config', GA_TRACKING_ID as string, {
    page_path: url,
  })
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = (action: Gtag.EventNames, { event_category, event_label, value }: Gtag.EventParams) => {
  window.gtag('event', action, {
    event_category,
    event_label,
    value,
  })
}

// 앱 버전 및 디바이스 정보 GTM 이벤트
export const sendAppGTMEvent = (runtimeVersion: string) => {
  if (typeof window !== 'undefined') {
    if (runtimeVersion !== 'web' && !window.NATIVE_APP_VERSION) {
      setTimeout(sendAppGTMEvent, 100)
      return
    }

    window.dataLayer?.push({
      event: 'page_view',
      userOs: window?.DEVICE_OS ?? 'web',
      userOsVersion: window?.DEVICE_OS_VERSION ?? 'web',
      userAppVersion: window?.NATIVE_APP_VERSION ?? runtimeVersion,
      userBuildVersion: window?.BUILD_VERSION ?? 'web',
      userDeviceModel: window?.DEVICE_MODEL ?? 'web',
      userDeviceType: window?.DEVICE_TYPE ?? 'web',
    })
  }
}
